import { __extends } from "tslib";
import React from 'react';
import { Url, URLS } from '@wix/da-url';
var LogoutItem = /** @class */ (function (_super) {
    __extends(LogoutItem, _super);
    function LogoutItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LogoutItem.prototype.render = function () {
        var _a = this.props, formRef = _a.formRef, token = _a.token, label = _a.label;
        return (React.createElement(React.Fragment, null,
            React.createElement("form", { id: "logout-form", ref: formRef, action: Url.buildFromPath(URLS.LOGOUT), method: "POST" },
                React.createElement("input", { type: "hidden", name: "validate_token", value: token, autoComplete: "off" })),
            label));
    };
    return LogoutItem;
}(React.Component));
export { LogoutItem };
export default LogoutItem;
//# sourceMappingURL=LogoutItem.js.map